export default __webpack_public_path__ + "static/media/iab-benefit-control.387ce2e4.svg";